import RespondentFlowApi from "./respondentFlow.api";
import { SessionUtils } from "../utils/session.utils";

// Legacy free-text log (DB only) - kept as-is for pages not yet migrated to the
// structured journey-event API below (logEvent).
const log = async (
  token,
  supplierToken,
  message,
  meta = "",
  campaignUid = "",
) => {
  let payload = {};
  payload.token = token;
  payload.supplier_token = supplierToken;
  payload.message = `CLIENT: ${message}`;
  payload.meta_data = meta;
  payload.campaign_uid = campaignUid;
  payload.log_time = new Date();

  try {
    await RespondentFlowApi.post("/v1/landing/save/log", payload);
  } catch (e) {
    console.error(e);
  }
};

const save_client_log = async (respondent, message, meta = {}) => {
  let payload = {};
  payload.token = respondent.token ?? "";
  payload.supplier_token = respondent.supplier_token ?? "";
  payload.message = message;
  payload.meta_data = meta ? JSON.stringify(meta) : "";
  payload.campaign_uid = respondent.campaign_uid ?? "";
  payload.log_time = new Date();

  try {
    await RespondentFlowApi.post("/v1/landing/save/log", payload);
  } catch (e) {
    console.error(e);
  }
};

// Structured journey event - ships to Loki (and dual-writes to the DB log
// table server-side) via /v1/landing/save/cloudlog. The journey/respondent
// tokens are attached automatically by respondentFlow.api.js's request
// interceptor, but token is also included in the body since the API's DB
// dual-write path reads request.token directly rather than the request context.
const logEvent = async (event, message = "", metadata = {}) => {
  const payload = {
    event,
    token: SessionUtils.getRespondentToken(),
    message,
    meta_data: metadata && Object.keys(metadata).length ? JSON.stringify(metadata) : "",
    log_time: new Date(),
  };

  try {
    await RespondentFlowApi.post("/v1/landing/save/cloudlog", payload);
  } catch (e) {
    console.error("[LoggerService] Failed to send event log", e);
  }
};

const LoggerService = {
  log,
  save_client_log,
  logEvent,
};

export default LoggerService;
